export default __webpack_public_path__ + "vacuum-filter.png?73a626453ab509e6b17e825fb89acc6c";